/* strpd. — theme.js — minimal */
(function () {
  'use strict';
  var doc = document, win = window;
  var prefersReducedMotion = win.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero: detect the ACTIVE media's aspect ratio → set --media-ratio for mobile CSS */
  var heroCanvas = doc.querySelector('.hero--has-media .hero-canvas');
  if (heroCanvas) {
    var vMobile = heroCanvas.querySelector('.hero-video--mobile');
    var vDesktop = heroCanvas.querySelector('.hero-video--desktop');
    var i = heroCanvas.querySelector('img');
    var mqMobile = win.matchMedia('(max-width: 720px)');

    function setRatio(w, h) { if (w > 0 && h > 0) heroCanvas.style.setProperty('--media-ratio', w + ' / ' + h); }

    function pickActive() {
      if (mqMobile.matches) return vMobile || vDesktop || i;
      return vDesktop || vMobile || i;
    }

    function updateFromActive() {
      var el = pickActive();
      if (!el) return;
      if (el.tagName === 'VIDEO') {
        if (el.videoWidth) setRatio(el.videoWidth, el.videoHeight);
        else el.addEventListener('loadedmetadata', function () { setRatio(el.videoWidth, el.videoHeight); }, { once: true });
      } else {
        if (el.naturalWidth) setRatio(el.naturalWidth, el.naturalHeight);
        else el.addEventListener('load', function () { setRatio(el.naturalWidth, el.naturalHeight); }, { once: true });
      }
    }

    updateFromActive();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', updateFromActive);
    else mqMobile.addListener(updateFromActive);
  }

  /* Header scroll state */
  var header = doc.querySelector('.site-header');
  function onScroll() { if (!header) return; header.classList.toggle('is-scrolled', win.scrollY > 8); }
  onScroll();
  win.addEventListener('scroll', onScroll, { passive: true });

  /* Reveal on intersect */
  var reveals = doc.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in win) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* Mobile menu */
  var menu = doc.querySelector('.mobile-menu');
  var menuToggle = doc.querySelector('[data-menu-toggle]');
  function openMenu() { if (menu) { menu.classList.add('is-open'); doc.body.style.overflow = 'hidden'; if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true'); } }
  function closeMenu() { if (menu) { menu.classList.remove('is-open'); doc.body.style.overflow = ''; if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false'); } }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menu) {
    menu.addEventListener('click', function (e) { if (e.target.matches('.veil, [data-menu-close]')) closeMenu(); });
    menu.querySelectorAll('.mm-links a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* Cart drawer */
  var drawer = doc.querySelector('.cart-drawer');
  var cartBtn = doc.querySelectorAll('[data-open-cart]');
  var cartCount = doc.querySelector('[data-cart-count]');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); doc.body.style.overflow = 'hidden'; renderCart(); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); doc.body.style.overflow = ''; } }
  cartBtn.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  if (drawer) drawer.addEventListener('click', function (e) { if (e.target.matches('.veil, [data-close-cart]')) closeDrawer(); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); closeDrawer(); } });

  function currency(cents) { return (cents / 100).toFixed(2) + ' ' + ((win.strpdShop && win.strpdShop.currency) || 'EGP'); }
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function updateCount(c) { if (cartCount) cartCount.textContent = c; }

  function renderCart() {
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.items');
    var subtotalEl = drawer.querySelector('.subtotal .v');
    var checkout = drawer.querySelector('[data-checkout]');
    if (!itemsEl) return;
    itemsEl.innerHTML = '<div class="cart-empty">Loading…</div>';
    fetchCart().then(function (cart) {
      updateCount(cart.item_count);
      if (!cart.items.length) {
        itemsEl.innerHTML = '<div class="cart-empty">Your bag is empty</div>';
        if (subtotalEl) subtotalEl.textContent = currency(0);
        if (checkout) checkout.setAttribute('disabled', 'disabled');
        return;
      }
      if (checkout) checkout.removeAttribute('disabled');
      itemsEl.innerHTML = cart.items.map(function (i) {
        var img = i.image ? '<img src="' + i.image + '" alt="' + (i.product_title || '') + '">' : '';
        var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="m">' + i.variant_title + '</div>' : '';
        return '<div class="cart-item" data-key="' + i.key + '">' +
          '<div class="thumb">' + img + '</div>' +
          '<div class="info"><div class="n">' + i.product_title + '</div>' + variant +
            '<div class="qty"><button data-qty="' + i.key + '" data-d="-1" aria-label="Decrease">−</button><span>' + i.quantity + '</span><button data-qty="' + i.key + '" data-d="1" aria-label="Increase">+</button></div>' +
          '</div>' +
          '<div class="p">' + currency(i.final_line_price) + '</div>' +
        '</div>';
      }).join('');
      if (subtotalEl) subtotalEl.textContent = currency(cart.total_price);
    });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function () { renderCart(); });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var key = b.getAttribute('data-qty');
      var d = parseInt(b.getAttribute('data-d'), 10);
      var row = b.closest('.cart-item');
      var qty = parseInt(row.querySelector('.qty span').textContent, 10) + d;
      changeQty(key, qty);
    });
  }

  doc.querySelectorAll('form[data-ajax-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.origText = btn.textContent; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Added'; setTimeout(function () { btn.textContent = btn.dataset.origText || 'Add to bag'; }, 1200); }
          openDrawer();
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.origText || 'Add to bag'; } });
    });
  });

  fetchCart().then(function (c) { updateCount(c.item_count); });

  /* PDP gallery */
  var gallery = doc.querySelector('.pdp-gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.frame img');
    gallery.querySelectorAll('.pdp-thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg && t.dataset.src) mainImg.src = t.dataset.src;
        gallery.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }
})();
